import {
  useGridApiContext,
  useGridSelector,
  gridPageCountSelector,
  gridPageSelector,
  gridPageSizeSelector,
  gridRowCountSelector,
} from '@mui/x-data-grid';
import { Box, Typography, Button } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const CustomPagination = ({ paginationText }) => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  const totalPages = pageCount;
  const startItem = page * pageSize + 1;
  const endItem = Math.min((page + 1) * pageSize, rowCount);

  const handlePageChange = (newPage) => {
    apiRef.current.setPage(newPage);
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 16px',
        flexWrap: 'wrap',
        gap: '0.5rem',
      }}
    >
      <Typography variant="body2" color="text.primary" sx={{ flexShrink: 1 }}>
        {paginationText ||
          (rowCount === 0 ? 'No results to display' : `Viewing ${startItem} - ${endItem} of ${rowCount} results`)}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          border: '1px solid #ccc',
          borderRadius: '20px',
        }}
      >
        <Button
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 0}
          sx={{
            borderRadius: 0,
            textTransform: 'none',
            fontWeight: 'bold',
            borderRight: '1px solid #ccc',
          }}
        >
          <ChevronLeftIcon />
          Previous
        </Button>
        <Button
          onClick={() => handlePageChange(page + 1)}
          disabled={page >= totalPages - 1}
          sx={{
            borderRadius: 0,
            textTransform: 'none',
            fontWeight: 'bold',
          }}
        >
          Next
          <ChevronRightIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default CustomPagination;
